
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { RoleWithPermissions } from '@/types/userRole';

interface RoleDeleteDialogProps {
  open: boolean;
  role: RoleWithPermissions;
  onClose: () => void;
  onConfirm: () => void;
}

const RoleDeleteDialog: React.FC<RoleDeleteDialogProps> = ({
  open,
  role,
  onClose,
  onConfirm
}) => {
  return (
    <AlertDialog open={open} onOpenChange={(open) => !open && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Role: {role.name}</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete this role? This action cannot be undone.
            {role.userCount > 0 && (
              <div className="mt-2 text-destructive font-medium">
                This role has {role.userCount} assigned users. You must reassign these users before deleting this role.
              </div>
            )}
            {role.isSystem && (
              <div className="mt-2 text-destructive font-medium">
                This is a system role and cannot be deleted.
              </div>
            )}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={role.userCount > 0 || role.isSystem}
            className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          >
            Delete Role
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default RoleDeleteDialog;
